import { Grid, Text } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/react'
import { useMarkup } from '../../contexts/MarkupProvider'
import { MdGraphicEq } from 'react-icons/md'

import { Total } from './Total'
import { JurosLucro } from './JurosLucro'
import { Link } from 'react-router-dom'

export function Vendas() {
  const { summaryData: dataFilter, summary, loading } = useMarkup()

  const outrosLucros =
    summary?.lucroSobreFrete +
    summary?.lucroCondicaoPagamento +
    summary?.jurosPagamentoAtrasado +
    summary?.sobraInnovation

  const lucroBrutoTotal = summary?.lucroBruto + outrosLucros

  return (
    <>
      {' '}
      <Grid templateColumns="repeat(3, 1fr)" w="100%" gap={12}>
        {/*<Quantidade dashboard={dashboard} summaryT={summaryT} valorTotalMesMarkup={valorTotalMesMarkup} />*/}
        <JurosLucro summary={summary} outrosLucros={outrosLucros} />
        <Total
          summary={summary}
          lucroBrutoTotal={lucroBrutoTotal}
          outrosLucros={outrosLucros}
        />
      </Grid>
      {/* <Button
        colorScheme="blue"
        fontSize=".8rem"
        size="sm"
        alignSelf="flex-end"
        disabled={loading}
        display="flex"
        alignItems="center"
        gap={2}
        as={Link}
        to="/markup/grafico"
      >
        <MdGraphicEq size={20} /> <Text fontSize=".8rem">Gráficos</Text>
      </Button> */}
    </>
  )
}
